import styled from "styled-components";

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  position: relative;
  width:  ${(props) => props.customwidth || "100%"};
`;

export const PrimaryButton = styled.button`
  background-color: ${(props) => props.bg || "#0C53BB"};
  color: ${(props) => props.customcolor || "#FFFFFF"};
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px;
  border: ${(props) => props.customborder || "none"};
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "40px"};
  opacity: ${(props) => (props.disabled ? "0.4" : "1")}; /* Reduce opacity when disabled */

  &:hover {
    background-color: ${(props) =>
      props.disabled ? props.bg || "#0C53BB" : props.bghover || "#0A47A3"}; /* No hover effect if disabled */
  }
`;

export const SeconadaryButton = styled.button`
  background-color: #0C53BB;
  color: #fff;
  font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 0.813rem;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
vertical-align: middle;

  border: 1px solid #DDDEE3;
  border-radius: 8px;
  width: ${(props) => props.width || "65px"};
  height: ${(props) => props.height || "32px"};
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? "0.4" : "1")}; /* Reduce opacity when disabled */

  &:hover {
    background-color: #0A4296;
  }
`;
export const MenuWrapper = styled.div`
  position: ${(props) => props.position || "absolute"};
  top: ${(props) => props.top || "35px"};
  right: ${(props) => props.right || "0px"};
  background: white;
  box-shadow: 0px 0px 4px 0px #00000014;
  border-radius: 6px;
  border: 1px solid #DDDEE3;
  z-index: 100;
  width: ${(props) => props.width || "220px"};
  height: auto;
  padding: 8px;

  .menu-item {
    display: flex;
    align-items: center;  
    padding: 8px;
    cursor: pointer;
    background: white;
    width: 100%;
    text-align: center;
    border-radius: 6px;
    border:none;
    gap:8px;
    font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 0.813rem;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;
color:#48566B;
justify-content: space-between;
    white-space: nowrap;
  }

  .menu-item img {
    margin-right: 8px;
  }

  .menu-item:hover {
    background: #E9E9ED;
    border-radius: 6px;
  }

  .danger {
    color: #AE3333;
  }
  .menu-item.danger:hover {
    background: var(--Color-Red-Red_075, #F7DEDE);
    border-radius: 8px;
  }
    .btnWrappergap-file{
    display:flex;
    gap: 8px;  
    }
    .btnWrappergap-file:hover {
    background: #E9E9ED;
    border-radius: 6px;
    }
    .btnWrappergap{
    display:flex;
    gap: 7px;
    }
    .btnWrapper{
    display:flex;
    }
`;
export const HorizondalLine = styled.hr`
  border: 1px solid #f3f4f7;
  width: 100%;
`;